import { useMe } from '@/hooks/use-me';
import { cls } from '@/utils/cls';
import { energyLabels } from '@/utils/format/battery';

export function EnergySuffix({ className }: { className?: string }) {
  const me = useMe();
  return (
    <div className={cls('text-xs text-gray-700', className)}>
      {energyLabels[me.config.powerUnit]}
    </div>
  );
}
